import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router"

import authReducer from "./Auth";
import chatReducers from "./chatReducers";
import settingsReducer from "./Settings";
import notification from "./notification";
import statistics from "./statistics";
import family from "./Family";
import invite from "./Invite";
import main from "./Main";

export default (history) => combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    setting: settingsReducer,
    chat: chatReducers,
    notification,
    statistics,
    family,
    invite,
    main
});